import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { PowerPlayerBoltInlineIcon } from '../../../assets/powerPlayerBoltInlineIcon';
import { isGameGuidePath } from '../../../gameGuide/gameGuideUtils';
import { thunkGoToGameGuidePage } from '../../../redux/actions/gameGuideActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { IconWithLabelDisplay } from '../../iconWithLabelDisplay';
const PowerPlayerFeatureIndicatorBase = ({ onClick, label, powerPlayerBoltColor }) => {
    const containerCss = useMemo(() => css(css `
          display: inline-block;
          margin-left: 10px;
          padding-right: 10px;
          background-color: rgba(255, 255, 255, 0.15);
          border: 2px solid rgba(0, 0, 0, 0.2);
          border-radius: 20px;
          user-select: none;
        `, onClick &&
        css `
            cursor: pointer;
            &:hover {
              background-color: rgba(255, 255, 255, 0.25);
            }
          `), [onClick]);
    return (_jsx("span", { css: containerCss, onClick: onClick, children: _jsx(IconWithLabelDisplay, { icon: _jsx(PowerPlayerBoltInlineIcon, { powerPlayerBoltColor: powerPlayerBoltColor }), label: label }) }));
};
const PowerPlayerFeatureAnchorIndicator = ({ isClickable, powerPlayerBoltColor, label: labelOverride }) => {
    const label = labelOverride || 'Power Player Feature';
    const contents = _jsx(PowerPlayerFeatureIndicatorBase, { label: label, powerPlayerBoltColor: powerPlayerBoltColor });
    return isClickable ? _jsx(Link, { to: '/guide/power-player', children: contents }) : contents;
};
const PowerPlayerFeatureDispatchIndicator = ({ isClickable, powerPlayerBoltColor, label: labelOverride }) => {
    const dispatch = useAppDispatch();
    const isPowerPlayer = useAppSelector((state) => state.selfData.isPowerPlayer);
    const onClick = useCallback(() => {
        dispatch(thunkGoToGameGuidePage('power-player'));
    }, [dispatch]);
    const label = labelOverride || (isPowerPlayer ? 'Power Player Feature' : 'Requires Power Player');
    return (_jsx("span", { style: isClickable ? {} : { fontSize: '80%' }, children: _jsx(PowerPlayerFeatureIndicatorBase, { onClick: isClickable ? onClick : undefined, label: label, powerPlayerBoltColor: powerPlayerBoltColor }) }));
};
export const PowerPlayerFeatureIndicator = ({ isClickable, powerPlayerBoltColor = 'yellow', label }) => {
    return isGameGuidePath() ? (_jsx(PowerPlayerFeatureAnchorIndicator, { isClickable: isClickable, powerPlayerBoltColor: powerPlayerBoltColor, label: label })) : (_jsx(PowerPlayerFeatureDispatchIndicator, { isClickable: isClickable, powerPlayerBoltColor: powerPlayerBoltColor, label: label }));
};
